import moment from "moment";

const isValid = date => moment(date).isValid();

const maxValue = new Date(8640000000000000);
const minValue = new Date(-8640000000000000);

export {
    isValid,
    minValue,
    maxValue
}